var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-event-attendance",
        "dialog-class": "base-modal omz-attend",
        "body-class": "p-0",
        "hide-header": "",
        "hide-header-close": "",
        "hide-footer": "",
        centered: "",
      },
    },
    [
      _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.texts.title))]),
      _c("div", { staticClass: "omz-modal-content" }, [
        _c("div", { domProps: { innerHTML: _vm._s(_vm.texts.content) } }),
      ]),
      _c("div", { staticClass: "attend-table-wrapper" }, [
        _c("img", {
          staticClass: "omz-coin",
          attrs: {
            src: `${_vm.$s3}/img/common/event/omz_attendance/coin.webp?${_vm.$ver}`,
          },
        }),
        _c("div", { staticClass: "attend-table" }, [
          _c("header", [
            _c("div", { staticClass: "attend-title" }, [
              _vm._v(_vm._s(_vm.texts.attend.title)),
            ]),
            _c("div", { staticClass: "usr-attend" }, [
              _vm._v(_vm._s(_vm.texts.attend.usrAttend(_vm.usrAttend))),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "attend" },
            [
              _c("OmzAttendance", {
                attrs: { usrAttend: _vm.usrAttend, type: "modal" },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "btn-wrapper" }, [
        _c(
          "button",
          {
            staticClass: "modal-btn confirm",
            attrs: { id: "modal-confirm-btn" },
            on: {
              click: function ($event) {
                return _vm.$bvModal.hide("modal-event-attendance")
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("modal.confirm")) + "\n    ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }